import { useState, useEffect } from 'react';
import axios from 'axios';

import * as Icons from '../../../images/icons/icons_component';

function EcshgHnfTrn_popup() {

    const [data, setData] = useState({});
    const [emogList, setEmogList] = useState([]);
    const [atchDta, setAtchDta] = useState([]);
    const sendData = JSON.parse(localStorage.getItem('ecshgHnfTrnData')) || {};
    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/trnlst/ecshgHnfEdcTraingRsltTrnDetail.do', {
                params: sendData
            });
            setData(response.data);
            console.log(response.data);
            console.log(sendData);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    };
    const [searchParams, setSearchParams] = useState({
        seCd: '',
        nm: '',
        emtInsttCd: '',
        edcDe: '',
        endDe: '',
        edcPlace: '',
        othbcAt: '',
        dcCn: '',
        gnrlRm: ''
    });

    const isUpdate = sendData.flag === 'update';
    const schdulFlag = sendData.schdulFlag === 'schdul';

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSearchParams((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setAtchDta(e.target.files[0]);
    };

    useEffect(() => {
        const fetchHospList = async () => {
            try {
                const response = await axios.get('/ptmiapi/trmsEmogList.do', {
                    params: {
                        grdc: 'Y',
                        loca: ''
                    }
                });
                setEmogList(response.data.emogList || []);
            } catch (error) {
                console.error('병원 목록 로딩 중 오류 발생:', error);
            }
        };
        fetchHospList();
        popupData();
    }, []);

    useEffect(() => {
        setSearchParams((prev) => ({
            ...prev,
            seCd: data.SE_CD,
            nm: data.NM,
            emtInsttCd: data.EMOGCODE,
            edcDe: isUpdate ? data.TR_EDC_DE : sendData.TR_OPMT_DT,
            endDe: isUpdate ? data.TR_END_DE : sendData.TR_OPMT_DT,
            edcPlace: data.EDC_PLACE,
            othbcAt: data.OTHBC_AT,
            dcCn: data.DC_CN,
            gnrlRm: data.GNRL_RM
        }));
        setAtchDta(data.ATCH_DTA);
    }, [data]);

    const del = async () => {
        const confirmMessage = "정말로 삭제하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);

        if (!confirmed) return;

        try {
            const response = await axios.get("/trmsapi/trnlst/ecshgHnfEdcTraingRsltTrnDetailSave.do", {
                params: sendData.DETAIL_SN,
            });
            alert(response.data.resultMessage);
        } catch (error) {
            console.error('데이터 저장 중 오류 발생:', error);
        }
    }

    const save = async () => {
        const requiredFields = [
            { key: 'seCd', label: '교육종류' },
            { key: 'nm', label: '참가자명' },
            { key: 'emtInsttCd', label: '소속' },
            { key: 'edcPlace', label: '장소' },
            { key: 'dcCn', label: '주요내용' },
        ];

        for (const field of requiredFields) {
            const value = searchParams[field.key];
            if (value === '' || value === null || value === undefined) {
                alert(`${field.label}을(를) 입력(선택)해야합니다.`);
                return;
            }
        }

        const confirmMessage = "저장하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);

        if (!confirmed) return;

        const addParams = {
            atchDta: atchDta,
            flag: sendData.flag,
            schdulFlag: sendData.schdulFlag,
            userId: localStorage.getItem("id"),
        }

        const totalObj = Object.assign({}, searchParams, addParams);

        try {
            const response = await axios.get("/trmsapi/trnlst/ecshgHnfEdcTraingRsltTrnDetailSave.do", {
                params: totalObj
            });
            alert(response.data.resultMessage);
        } catch (error) {
            console.error('데이터 저장 중 오류 발생:', error);
        }
    };

    return (
        <div className='popup_container bg_tr_bg'>
            <div className='flex justify-between'>
                <h5 className='sub_title m-0 p-0'>교육 및 훈련</h5>
                <div className='flex gap-1'>
                    {isUpdate && (
                        <button onClick={del} title="삭제" className='search_btn bg_co_black justify-self-end'>
                            <Icons.DeleteCircle16w/>삭제
                        </button>
                    )}
                    <button onClick={save} title={isUpdate ? '수정' : '저장'} className='search_btn bg_tr_primary justify-self-end'>
                        <Icons.Save16w />{isUpdate ? '수정' : '저장'}
                    </button>
                </div>
            </div>
            <div className='com-search tr_pop_th_bg border-l border-r'>
                <form>
                    <hr className='border-t-2 tr_border_soft' />
                    <table>
                        <colgroup>
                            <col width="15%" />
                            <col width="35%" />
                            <col width="15%" />
                            <col width="35%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>연번</th>
                                <td>{sendData.IEM_ID || ''}</td>
                                <th>교육 종류</th>
                                <td>
                                    <select
                                        id="seCd"
                                        name="seCd"
                                        className='w-full'
                                        value={searchParams.seCd}
                                        onChange={handleChange}>
                                        <option value="">선택</option>
                                        <option value="ED01">국내대회</option>
                                        <option value="ED04">국내교육</option>
                                        <option value="ED05">주기교육</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>참가자명</th>
                                <td>
                                    <input type='text'
                                        id='nm'
                                        name='nm'
                                        className='input_style'
                                        value={searchParams.nm}
                                        onChange={handleChange} />
                                </td>
                                <th>소속명</th>
                                <td>
                                    <select
                                        name="emtInsttCd"
                                        id="emtInsttCd"
                                        className='w-full'
                                        value={searchParams.emtInsttCd}
                                        onChange={handleChange}
                                    >
                                        <option value="">선택</option>
                                        {emogList.map((hosp) => (
                                            <option key={hosp.emogcode} value={hosp.emogcode}>
                                                {hosp.emogdesc}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>일정</th>
                                <td>
                                    <input
                                        type="date"
                                        name="edcDe"
                                        value={searchParams.edcDe}
                                        onChange={handleChange}
                                    />
                                    &nbsp;~&nbsp;
                                    <input
                                        type="date"
                                        name="endDe"
                                        value={searchParams.endDe}
                                        onChange={handleChange}
                                        min={searchParams.edcDe}
                                    />
                                </td>
                                <th>장소</th>
                                <td>
                                    <input type='text'
                                        id='edcPlace'
                                        name='edcPlace'
                                        className='input_style'
                                        value={searchParams.edcPlace}
                                        onChange={handleChange} />
                                </td>
                            </tr>
                            <tr>
                                <th>증빙자료</th>
                                <td colSpan={3}>
                                    <input
                                        type="file"
                                        id="atchDta"
                                        name="atchDta"
                                        onChange={handleFileChange} />
                                </td>
                                <th colSpan={2}></th>
                            </tr>
                            {schdulFlag && !isUpdate ? <tr>
                                <th>공개 여부</th>
                                <td>
                                    <select
                                        id="othbcAt"
                                        name="othbcAt"
                                        value={searchParams.othbcAt}
                                        onChange={handleChange}
                                    >
                                        <option value="Y">공개</option>
                                        <option value="N">비공개</option>
                                    </select>
                                </td>
                                <th colSpan={2}></th>
                            </tr> : ''}
                            <tr>
                                <th>주요내용</th>
                                <td colSpan="3">
                                    <textarea
                                        id="dcCn"
                                        name="dcCn"
                                        rows="10"
                                        className='textarea_style'
                                        value={searchParams.dcCn}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>비고</th>
                                <td colSpan="3">
                                    <textarea
                                        id="gnrlRm"
                                        name="gnrlRm"
                                        rows="10"
                                        className='textarea_style'
                                        value={searchParams.gnrlRm}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            {isUpdate && (
                                <tr>
                                    <th>생성일</th>
                                    <td>{data.TR_CREAT_DT}</td>
                                    <th>수정일</th>
                                    <td>{data.TR_UPDT_DT || ''}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </form>
            </div>
        </div >
    );
}
export default EcshgHnfTrn_popup;
